export const URL_FILES = 'https://raw.githubusercontent.com/GoldenkovVitali/rslang-data/master/';
